import { lazy } from 'react';

import ResultMessage, { WinMessageBasic } from '@ezugi/bootstrap/src/features/game-results/ResultMessage';
import { useGameResults } from '@ezugi/bootstrap/src/features/game-results/useGameResults';

import { isBackAndLayOnURL } from '../../utils';
import { resultMessageClassName } from './ResultDisplay/style';

const ResultDisplayDefault = lazy(() => import('./ResultDisplay'));
const ResultDisplayBL = lazy(() => import('./ResultDisplay/BackAndLay'));

const ResultDisplay = isBackAndLayOnURL ? ResultDisplayBL : ResultDisplayDefault;

const ODTPResultMessage = () => {
  const { isWinner, winAmount } = useGameResults();

  return (
    <ResultMessage className={resultMessageClassName(!isBackAndLayOnURL)}>
      <ResultDisplay />

      {isWinner && (
        <WinMessageBasic winAmount={winAmount} />
      )}
    </ResultMessage>
  );
};

export default ODTPResultMessage;
